export const establishLink = (data, sendFpData, renderIframe) => {
    return new window.PwyWebSocket({
        env: data.env, // 正式环境: prod, 测试环境: test
        tin: data.tin, // /tin为获取userKey时的税号
        eid: data.eid, // eid为获取userKey时的用户eid
        client_id: data.client_id, // 发票云分配的client_id
        sign: data.sign, // 签名规则：MD5(client_id + client_secret + timestamp)
        timestamp: data.timestamp || data.timeStamp, // 签名时的时间戳
        name: data.linkKey, // 连接名称，选择发票前获取的linkKey
        sourceType: "socket", // 默认socekt, 对于不支持socket的端请设置为polling，java端的轮询参考5
        // env: "test", // 正式环境: prod, 测试环境: test
        // tin: "914403006188392540", // /tin为获取userKey时的税号
        // eid: "7541982975484196162", // eid为获取userKey时的用户eid
        // client_id: "vc0c6hjlgnKCic", // 发票云分配的client_id
        // sign: "7c2b97560c28c5cdfb56e6f23050dad5", // 签名规则：MD5(client_id + client_secret + timestamp)
        // timestamp: "1626852307832", // 签名时的时间戳
        // name: "d40655ec4b2a4ffcba94c780294663ab", // 连接名称，选择发票前获取的linkKey
        // sourceType: "socket", // 默认socekt, 对于不支持socket的端请设置为polling，java端的轮询参考5
        onOpen: function (msg) {
            // 连接成功的回调
            // eslint-disable-next-line react/no-this-in-sfc
            renderIframe(data.userKey, data.linkKey)
        },
        onMessage: function (msg, callBack) {
            // msg为接收到的消息， 消息格式：{"type":"saveBill", data: {}}
            // 当type为saveBill时, data的数据为导入的发票数据，具体格式参考4.3
            // 当type为saveEntrys时, data的数据为分录调整后的数据，具体格式参考6.4
            // 当type为updateInvoice, data的数据为修改的发票基本信息，具体格式参考14.3
            // 接收到消息后，企业处理好自己业务, 如果要调用查看发票界面（调用6.3接口进行缓存），处理完成关闭窗口即可
            console.log(msg)
            sendFpData(msg.data.invoiceSerialNos)
            callBack && callBack(msg)
        },
        onError: function (errText, errCode) {
            // 失败时的回调
            console.log(`连接失败${errCode}${errText}`)
        },
        // 关闭连接, 接受到消息之后需要先关闭连接，需要再次使用需要重新创建socket对象
    })
}
